import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";
import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";

import { INVOICE_PERIODS_QUERY } from "./useInvoiceAvailablePeriods";

const INVOICE_CREATE_FOR_PERIOD_MUTATION = gql(`
  mutation InvoiceCreate($input: GqlInvoiceCreateInput!) {
    invoiceCreate(input: $input) {
      id
      createdAt
    }
  }
`);

export function useInvoiceCreateForPeriod() {
    const { client } = useRequireCurrentClient();
    const [createInvoiceAsync, { loading, error }] = useMutation(INVOICE_CREATE_FOR_PERIOD_MUTATION);

    return {
        loading,
        error,
        createInvoiceAsync: (year: number, month: number) =>
            createInvoiceAsync({
                refetchQueries: [INVOICE_PERIODS_QUERY],
                variables: {
                    input: {
                        year,
                        month,
                        clientId: client.id,
                    },
                },
            }),
    };
}
